<template>
    <div class="container-fluid">
        <!-- <div class="row" style="margin-bottom: 15px;">
            <div class="col-6 col-sm-6 col-md-6 col-lg-3 col-xl-5">
                <h5 style="color: #666666; margin-top: 5px; margin-bottom: 0px;">Dashboard</h5>
            </div>
            <div class="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-4">
                <span class="tit-card-dash"
                    style="float: right; font-weight: 500!important; font-size: 12px!important; margin-top: 7px;"><i
                        class="fa fa-calendar"></i> {{ displayperiodo }} </span>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-2">
                <div class="dropdown">
                    <button type="button" class="btn btn-light btn-sm btn-block" data-toggle="modal"
                        data-target="#mddefinirperiododash">
                        <i class="fa fa-calendar"></i> Selecionar Período
                    </button>
                </div>
            </div>
     
        </div> -->
        <div class="row" style="margin-bottom: 15px;">
            <div class="col-6 col-sm-6 col-md-6 col-lg-3 col-xl-5">
                <h5 style="color: #666666; margin-top: 5px; margin-bottom: 0px;">Dashboard</h5>
            </div>
            
            <div class="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-4">
                <span class="tit-card-dash"
                    style="float: right; font-weight: 500!important; font-size: 12px!important; margin-top: 7px;">
                    <i class="fa fa-calendar"></i> {{ displayperiodo }}
                </span>
            </div>
            
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2 mb-2">
                <div class="dropdown">
                    <button type="button" class="btn btn-light btn-sm btn-block" data-toggle="modal"
                        data-target="#mddefinirperiododash">
                        <i class="fa fa-calendar"></i> Selecionar Período
                    </button>
                </div>
            </div>
            
            <!-- Botão de Sair -->
            <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-1 mb-2">
                <button type="button" class="btn btn-warning btn-sm btn-block" @click.prevent="$router.go(-1)">
                    <i class="fa fa-sign-out-alt"></i> Sair
                </button>
            </div>
            
        </div>

        <div class="row">
            <div class="container-fluid h-100 d-flex flex-column p-0">
                <!-- Barra superior com carrossel de widgets -->
                <div class="accordion" id="accordionExample">
                    <div class="card">
                        <div class="card-header" style="background-color: white;" id="headingOne">                    
                            <button class="btn btn-link text-left btn-widget-dash" type="button" data-toggle="collapse" 
                                @click.prevent="mtdchangechevron()"
                                data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                Widgets <i :class="colapsed ? 'fa fa-chevron-down icone-gira-cima' : 'fa fa-chevron-down icone-gira-baixo'"></i>
                            </button>                            
                        </div>

                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                            data-parent="#accordionExample">
                            <div class="bg-white border-bottom py-2 px-3">
                                <div class="d-flex flex-nowrap overflow-auto pb-2 listacards" style="gap: 10px;">
                                    <div v-for="card in availableCards" :key="card.id" v-show="card.visible" v-on:dblclick="counter += 1, mtdcliqueduplo(card)" class="card flex-shrink-0"
                                        draggable="true" @dragstart="handleDragStart(card)" :style="{
                                            width: '150px',
                                            opacity: isCardDropped(card.id) ? 0.4 : 1,
                                            cursor: isCardDropped(card.id) ? 'not-allowed' : 'grab'
                                        }">
                                        <div class="card-body text-center">
                                            <i :class="card.icon" ></i>
                                            {{ card.label }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Conteúdo principal -->
                <div class="flex-grow-1 p-3 dropzone bg-light" style="min-height: 50vh;" @dragover.prevent @drop="handleDrop">
                    <draggable v-model="droppedCards" group="widgets" class="row" handle=".drag-handle" @end="saveView">
                        <div v-for="(item, index) in droppedCards" :key="item.id" :class="item.class"
                            style="padding-top: 20px;">
                            <div class="card card-drograble h-100">
                                <div class="card-header card-dash">
                                    <div class="d-flex justify-content-between align-items-start">
                                        <span class="drag-handle me-2" style="cursor: move;">☰</span>
                                        <h6 class="mb-0"><i :class="item.icon" ></i> {{ item.label }}</h6>
                                        <span class="me-2" @click="removeCard(item.id)"
                                        style="cursor: pointer;">✖</span>
                                    </div>
                                </div>
                                <div class="card-body" style="min-height: 300px;">
                                    <dashboard_skeleton v-show="item.isLoading"></dashboard_skeleton>
                                    <component v-show="!item.isLoading" :is="item.id" v-bind="item.props" :key="item.key" @handlerLoader="(bool) => item.isLoading = bool" />
                                </div>
                            </div>
                        </div>
                    </draggable>
                </div>
            </div>
        </div>

        <!-- Modal para definição do período para a dashboard -->
        <div class="modal fade" id="mddefinirperiododash" tabindex="-1" role="dialog"
            aria-labelledby="definirperiododashLabel" aria-hidden="true">
            <div class="modal-dialog modal-md modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="definirperiododashLabel"><i class="fa fa-calendar"></i> Definição de
                            período
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-9 border-right nao-imprimir">
                                <span class="lblselect2">Filial:</span>
                                <select id="cbfilial" data-placeholder="Selecione uma filial" v-model="lstfiliais"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-md-3" style="padding-top: 20px;" >
                                <button type="button" @click.prevent="mtdbuscarfiliais()" title="Importar minhas filiais" class="btn btn-primary btn-sm btn-block"><i class="fa fa-reply" aria-hidden="true"></i></button>
                            </div>
                        
                            <div class="col-md-12">
                                <label for="eddtini">De:</label>
                                <div class="input-group">
                                    <date-picker id="eddtini" v-model="pdtini" :config="options"
                                        class="form-control form-control-sm"></date-picker>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <label for="eddtfim">até:</label>
                                <div class="input-group">
                                    <date-picker id="eddtfim" v-model="pdtfim" :config="options"
                                        class="form-control form-control-sm"></date-picker>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button"  @click.prevent="mtdadicionafiliais()" class="btn btn-primary btn-sm"><i class="fa fa-check" aria-hidden="true"></i> Salvar  filiais </button>
                
                        <button type="button" class="btn btn-green btn-sm" @click.prevent="mtdresultadofaturamento()"
                            data-dismiss="modal"><i class="fa fa-check"></i> Aplicar período</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import util from '../utilitarios/util'
import * as moment from 'moment';
import draggable from 'vuedraggable'
import Resumoped from './cards/Resumoped.vue'
import Totalestoque from './cards/Totalestoque.vue'
import Demfinanceiro from './cards/Demfinanceiro.vue'
import Demvendedores from './cards/Demvendedores.vue'
import Democompras from './cards/Democompras.vue'
import Topfive from './cards/Topfive.vue'
import TopfiveQtd from './cards/TopfiveQtd.vue'
import Picodevendas from './cards/Picodevendas.vue';
import Metaindividual from './cards/Metaindividual.vue';
import Mytopfive from './cards/Mytopfive.vue';
import Metavendedores from './cards/Metavendedores.vue';
import Demoresultadoseries from './cards/Demoresultadoseries.vue';
import Demtecnicos from './cards/Demtecnicos.vue';
import Comprasfiliais from './cards/Comprasfiliais.vue';
import Comprasetores from './cards/Comprasetores.vue';
import Compragrupos from './cards/Compragrupos.vue';
import Compramarca from './cards/Compramarca.vue';
import Metafilial from './cards/Metafilial.vue';
import Metarecebimento from './cards/Metarecebimento.vue';
import Vendasvendedores from './cards/Vendasvendedores.vue';
import Vendassubgrupos from './cards/Vendassubgrupos.vue';
import Vendassetores from './cards/Vendassetores.vue';
import Vendasplanospagamento from './cards/Vendasplanospagamento.vue';
import Vendasmunicipios from './cards/Vendasmunicipios.vue';
import Vendasmarcas from './cards/Vendasmarcas.vue';
import Vendasgrupos from './cards/Vendasgrupos.vue';
import Vendasformaspagamento from './cards/Vendasformaspagamento.vue';
import Vendasfiliais from './cards/Vendasfiliais.vue';
import Vendascategorias from './cards/Vendascategorias.vue';
import Variacaofaturamento from './cards/Variacaofaturamento.vue';
import Previsaorecebimento from './cards/Previsaorecebimento.vue';
import Previsaopagamento from './cards/Previsaopagamento.vue';
import Produtosparados from './cards/Produtosparados.vue';
import Saldocaixa from './cards/Saldocaixa.vue';
import Toptengiro from './cards/Toptengiro.vue';
import FaturamentoPorFilial from './cards/FaturamentoPorFilial.vue';
import Vendasbairros from './cards/Vendasbairros.vue';

import Skeletondashboard from '../components/cmpskeletondashboard2.vue';


export default {
    name: "Dashboard",
    components: {
        draggable,
        Resumoped,
        Totalestoque,
        Demfinanceiro,
        Demvendedores,
        Topfive,
        TopfiveQtd,
        Democompras,
        Picodevendas,
        Metaindividual,
        Demoresultadoseries,
        Demtecnicos,
        Mytopfive,
        Metavendedores,
        Comprasfiliais,
        Comprasetores,
        Compragrupos,
        Compramarca,
        Metafilial,
        Metarecebimento,
        Vendasvendedores,
        Vendassubgrupos,
        Vendassetores,
        Vendasplanospagamento,
        Vendasmunicipios,
        Vendasmarcas,
        Vendasgrupos,
        Vendasformaspagamento,
        Vendasfiliais,
        Vendascategorias,
        Variacaofaturamento,
        Previsaorecebimento,
        Previsaopagamento,
        Produtosparados,
        Saldocaixa,
        FaturamentoPorFilial,
        Vendasbairros,
        Toptengiro,
        'dashboard_skeleton'   : Skeletondashboard
    },
    data() {
        return {
            draggedCard: null,
            droppedCards: [],
            isSidebarCollapsed: false,
            lstfiliais: [],
            colapsed: false,

            //skeleton 
            isloading                           : false,


            displayperiodo: '',

            pdtini: moment().format('01/MM/YYYY'),
            pdtfim: moment().endOf('month').format('DD/MM/YYYY'),

            resizingIndex: null,
            startX: 0,
            startY: 0,
            startWidth: 0,
            startHeight: 0,

            options: {
                format: 'DD/MM/YYYY',
                useCurrent: false,
                locale: 'pt-BR'
            },

            availableCards: [
                {
                    id: "Resumoped",
                    key: "",
                    label: "Resultado do faturamento",
                    icon : "fa fa-line-chart", // Indicador de crescimento/faturamento
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 0,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Totalestoque",
                    key: "",
                    label: "Total Estoque",
                    icon : "fa fa-line-chart", // Indicador de crescimento/faturamento
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 0,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Topfive",
                    key: "",
                    label: "Top 10 produtos (valor)",
                    icon : "fa fa-trophy", // Ranking por valor
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 0,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "TopfiveQtd",
                    key: "",
                    label: "Top 10 produtos (qtd)",
                    icon : "fa fa-sort-amount-desc", // Ranking por quantidade
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 0,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Demvendedores",
                    key: "",
                    label: "Dem. de vendedores",
                    icon : "fa fa-users", // Equipe de vendas
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 0,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Demfinanceiro",
                    key: "",
                    label: "Dem. financeiro",
                     icon : "fa fa-money", // Relatório financeiro
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 0,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Democompras",
                    key: "",
                    label: "Dem. compras",
                    icon : "fa fa-shopping-cart", // Compras
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 0,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Picodevendas",
                    key: "",
                    label: "pico de vendas",
                    icon : "fa fa-area-chart", // Picos de vendas (gráfico)
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 0,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Metaindividual",
                    key: "",
                    label: "Meta individual",
                    icon : "fa fa-bullseye", // Foco em meta
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 0,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Mytopfive",
                    key: "",
                    label: "Meus top 10 produtos",
                    icon : "fa fa-star", // Destaques pessoais
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 0,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Metavendedores",
                    key: "",
                    label: "Meta de vendedores",
                    icon : "fa fa-line-chart", // Indicadores de meta da equipe
                    class: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Comprasfiliais",
                    key: "",
                    label: "Compras por Filiais",
                    icon : "fa fa-line-chart", // Indicadores de compras por filiais
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Comprasetores",
                    key: "",
                    label: "Compras por Setores",
                    icon : "fa fa-line-chart", // Indicadores de compras por filiais
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Metafilial",
                    key: "",
                    label: "Meta Filial",
                    icon : "fa fa-line-chart", // Indicadores de compras por filiais
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Metarecebimento",
                    key: "",
                    label: "Meta Recebimento",
                    icon : "fa fa-line-chart", // Indicadores de compras por filiais
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Compragrupos",
                    key: "",
                    label: "Compras por Grupos",
                    icon : "fa fa-line-chart", // Indicadores de compras por filiais
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Compramarca",
                    key: "",
                    label: "Compras por Marca",
                    icon : "fa fa-line-chart", // Indicadores de compras por filiais
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Vendasvendedores",
                    key: "",
                    label: "Vendedores",
                    icon : "fa fa-pie-chart", // Indicadores de compras por filiais
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Vendassubgrupos",
                    key: "",
                    label: "Subgrupos",
                    icon : "fa fa-pie-chart", // Indicadores de compras por filiais
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Vendassetores",
                    key: "",
                    label: "Setores",
                    icon : "fa fa-pie-chart", // Indicadores de compras por filiais
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Vendasplanospagamento",
                    key: "",
                    label: "Planos de Pagamento",
                    icon : "fa fa-pie-chart", // Indicadores de compras por filiais
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Vendasmunicipios",
                    key: "",
                    label: "Municípios",
                    icon : "fa fa-pie-chart", // Indicadores de compras por filiais
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Vendasmarcas",
                    key: "",
                    label: "Marcas",
                    icon : "fa fa-pie-chart", // Indicadores de compras por filiais
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Vendasgrupos",
                    key: "",
                    label: "Grupos",
                    icon : "fa fa-pie-chart", // Indicadores de compras por filiais
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Vendasformaspagamento",
                    key: "",
                    label: "Formas de Pagamento",
                    icon : "fa fa-pie-chart", // Indicadores de compras por filiais
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Vendasfiliais",
                    key: "",
                    label: "Filiais",
                    icon : "fa fa-pie-chart", // Indicadores de compras por filiais
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Vendascategorias",
                    key: "",
                    label: "Categorias",
                    icon : "fa fa-pie-chart", // Indicadores de compras por filiais
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Demoresultadoseries",
                    key: "",
                    label: "DRE. por filial",
                    icon : "fa fa-line-chart", // Resultado consolidado por filial
                    class: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Demtecnicos",
                    key: "",
                    label: "Demonstrativo técnico",
                    icon : "fa fa-pie-chart", // Resultado consolidado por filial
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,

                    },
                    isLoading: true,
                    //isloading
                },
                {
                    id: "Variacaofaturamento",
                    key: "",
                    label: "Variação do Faturamento",
                    icon : "fa fa-line-chart", // Resultado consolidado por filial
                    class: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "FaturamentoPorFilial",
                    key: "",
                    label: "Faturamento por Filial",
                    icon : "fa fa-line-chart", // Resultado consolidado por filial
                    class: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Vendasbairros",
                    key: "",
                    label: "Vendas por Bairros",
                    icon : "fa fa-line-chart", 
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Previsaorecebimento",
                    key: "",
                    label: "Previsão de Recebimento",
                    icon : "fa fa-line-chart", // Resultado consolidado por filial
                    class: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Previsaopagamento",
                    key: "",
                    label: "Previsão de Pagamento",
                    icon : "fa fa-line-chart", // Resultado consolidado por filial
                    class: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Produtosparados",
                    key: "",
                    label: "Produtos parados",
                    icon : "fa fa-sort-amount-desc", // Resultado consolidado por filial
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Saldocaixa",
                    key: "",
                    label: "Saldo em caixa",
                    icon : "fa fa-money", // Resultado consolidado por filial
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
                {
                    id: "Toptengiro",
                    key: "",
                    label: "Top 10 giro produto",
                    icon : "fa fa-sort-amount-desc", // Resultado consolidado por filial
                    class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4",
                    visible: false,
                    props: {
                        utodasfiliais: 1,
                        idfilialmeta: 0,
                        pdtini: moment().format('01/MM/YYYY'),
                        pdtfim: moment().endOf('month').format('DD/MM/YYYY'),
                        lstfiliais: [],
                        qtdnotaspendentes: 0,
                    },
                    isLoading: true,
                },
            ]
        };
    },
    mounted() { //colocar o que eles salvaram
        let vself = this;

        let sqliniusuario   = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
	    let sqlfimusuario   = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';                

 
        let mesini = vself.pdtini.split('/')[1];
        let mesfim = vself.pdtfim.split('/')[1];
        vself.displayperiodo = `${mesini}/${vself.pdtini.split('/')[2]} até ${mesfim}/${vself.pdtfim.split('/')[2]}`;


        setTimeout(() => { //resolver promisses? não meu amigo, isso aqui é infalivel boas praticas até chora - guga 
            vself.carregadash();
        }, 2000);



        if (typeof ResizeObserver !== 'undefined') {
            this.observer = new ResizeObserver(entries => {
                entries.forEach(entry => {
                    //pode ser util para atualizar o DOM : não mexer - guga
                });
            });
            this.observer.observe(this.$el);
        }
         $("#cbfilial").select2({
            multiple: true, // Permite múltiplas seleções
            placeholder: 'Selecione 1 ou mais filiais',
            allowClear: true,
            id: function (e) {return e.codfil},
            ajax: {						
                url: vself.$store.state.configpaths.pathselect2sql,						
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q		: params.term,
                        idclientesac : vself.$store.state.filialpadrao.idcliente,
                        sqlini	: sqliniusuario,
                        sqlfim	: sqlfimusuario,
                        cpid	: 'codfil',
                        cpdesc	: 'fantasia'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.lstfiliais = $("#cbfilial").val();
        });
    },
    beforeDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    },
    methods: {
        mtdadicionafiliais() {
            const selecionadas = $('#cbfilial').select2('data'); // pega os dados completos (id + text)
            
            // Mapeia apenas o necessário: id e texto
            const filiaisFormatadas = selecionadas.map(f => ({
                id: f.id,
                text: f.text
            }));

            localStorage.setItem('filiaisSelecionadas', JSON.stringify(filiaisFormatadas));
            this.$toastr.s('Salvo com sucesso!', 'Sucesso');
        },
        mtdbuscarfiliais() {
            const filiaisSalvas = localStorage.getItem('filiaisSelecionadas');

            if (filiaisSalvas) {
                const arrFiliais = JSON.parse(filiaisSalvas);

                // Limpa as opções atuais
                $('#cbfilial').empty();

                // Adiciona as opções novamente
                arrFiliais.forEach(filial => {
                    const option = new Option(filial.text, filial.id, true, true); // já selecionado
                    $('#cbfilial').append(option);
                });

                $('#cbfilial').trigger('change'); // atualiza visual do select2
                this.lstfiliais = arrFiliais.map(f => f.id); // só os IDs pro Vue
            }
        },
        mtdGerarStringAleatoria(){
            return util.GerarStringAleatoria();
        },  
        mtdchangechevron(){
            this.colapsed = this.colapsed ?  false :  true;
        },
        carregadash(){
            let vself = this;
            vself.isloading = true;
            //pega as informações do dash 
            let parametros      = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           valor  : 'pegadashboard'},
                {parametro: 'idusuario',    valor  : vself.$store.state.usuario.id},
    
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
            retorno.then(function (response) {
                const saved = response.data;
                if (saved) {
                    for (let index = 0; index < vself.availableCards.length; index++) {
                        vself.availableCards[index].visible = false;
                        
                        if (vself.permitecard(vself.availableCards[index].id, vself.usuariologado)) {
                            vself.availableCards[index].visible = true;
                        }
                        //vself.availableCards[index].visible = true;
                    }

                    //bem aqui tem que passar um parametro pra pegar a data atual e a filial certinha - guga 
                    let lstdashs      = JSON.parse(saved);
                    lstdashs.forEach(card => {
                        card.key = vself.mtdGerarStringAleatoria();
                        if (card.props) {
                            card.props.pdtini     = vself.pdtini;
                            card.props.pdtfim     = vself.pdtfim;
                            card.props.lstfiliais = vself.lstfiliais;
                        }
                    });
                    vself.droppedCards = lstdashs;
                    vself.isloading = false;
                }
            }).catch(function (response) {
                vself.isloading = false;
            });
        },
        permitecard(cadid, usuariologado){
            console.log(usuariologado);
            switch (cadid) {
                case 'Resumoped':
                    return parseInt(usuariologado.cardresumopedidos) === 1 ? true : false;
                break;   
                case 'Totalestoque':
                    return parseInt(usuariologado.cardtotalestoque) === 1 ? true : false;
                break;
                case 'Demfinanceiro':
                    return parseInt(usuariologado.cardfinanceiro) === 1 ? true : false;
                break;
                case 'Demvendedores':
                    return parseInt(usuariologado.cardvendedores) === 1 ? true : false;
                break;
                case 'Topfive':
                    return parseInt(usuariologado.cardtop5produtos) === 1 ? true : false;
                break;
                case 'TopfiveQtd':
                    return parseInt(usuariologado.cardtop5produtos) === 1 ? true : false;
                break;
                case 'Democompras':
                    return parseInt(usuariologado.cardcompra) === 1 ? true : false;
                break;
                case 'Picodevendas':
                    return parseInt(usuariologado.cardpicovendas) === 1 ? true : false;
                break;
                case 'Metaindividual':
                    return parseInt(usuariologado.cardmetaindividual) === 1 ? true : false;
                break;
                case 'Demoresultadoseries':
                    return parseInt(usuariologado.carddemoresultado) === 1 ? true : false;
                break;              
                case 'Demtecnicos':
                    return parseInt(usuariologado.carddemotecnico) === 1 ? true : false;
                break;
                case 'Mytopfive':
                    return parseInt(usuariologado.cardtop5produtos) === 1 ? true : false;
                break;
                case 'Metavendedores':
                    return parseInt(usuariologado.cardmetas) === 1 ? true : false;
                break;
                case 'Comprasfiliais':
                    return parseInt(usuariologado.cardcomprasfiliais) === 1 ? true : false;
                break;
                case 'Comprasetores':
                    return parseInt(usuariologado.cardcomprassetores) === 1 ? true : false;
                break;
                case 'Compragrupos':
                    return parseInt(usuariologado.cardcomprasgrupos) === 1 ? true : false;
                break;
                case 'Compramarca':
                    return parseInt(usuariologado.cardcomprasmarcas) === 1 ? true : false;
                break;
                case 'Metafilial':
                    return parseInt(usuariologado.cardmetafilial) === 1 ? true : false;
                break;
                case 'Vendasvendedores':
                    return parseInt(usuariologado.cardvendasvendedores) === 1 ? true : false;
                break;
                case 'Vendassubgrupos':
                    return parseInt(usuariologado.cardvendassubgrupos) === 1 ? true : false;
                break;
                case 'Vendassetores':
                    return parseInt(usuariologado.cardvendassetores) === 1 ? true : false;
                break;
                case 'Vendasplanospagamento':
                    return parseInt(usuariologado.cardvendasplanospagamento) === 1 ? true : false;
                break;
                case 'Vendasmunicipios':
                    return parseInt(usuariologado.cardvendasmunicipios) === 1 ? true : false;
                break;
                case 'Vendasmarcas':
                    return parseInt(usuariologado.cardvendasmarcas) === 1 ? true : false;
                break;
                case 'Vendasgrupos':
                    return parseInt(usuariologado.cardvendasgrupos) === 1 ? true : false;
                break;
                case 'Vendasformaspagamento':
                    return parseInt(usuariologado.cardvendasformaspagamento) === 1 ? true : false;
                break;
                case 'Vendasfiliais':
                    return parseInt(usuariologado.cardvendasfiliais) === 1 ? true : false;
                break;
                case 'Vendascategorias':
                    return parseInt(usuariologado.cardvendascategorias) === 1 ? true : false;
                break;
                case 'Variacaofaturamento':
                    return parseInt(usuariologado.cardvariacaofaturamento) === 1 ? true : false;
                break;
                case 'Previsaorecebimento':
                    return parseInt(usuariologado.cardprevisaorecebimento) === 1 ? true : false;
                break;
                case 'Previsaopagamento':
                    return parseInt(usuariologado.cardprevisaopagamento) === 1 ? true : false;
                break;
                case 'Produtosparados':
                    return parseInt(usuariologado.cardprodutosparados) === 1 ? true : false;
                break;
                case 'Saldocaixa':
                    return parseInt(usuariologado.cardsaldocaixa) === 1 ? true : false;
                break;
                case 'Toptengiro':
                    return parseInt(usuariologado.cardgiroproduto) === 1 ? true : false;
                break;
                case 'FaturamentoPorFilial':
                    return parseInt(usuariologado.cardfaturamentofilial) === 1 ? true : false;
                break;
                case 'Vendasbairros':
                    return parseInt(usuariologado.cardvendasbairros) === 1 ? true : false;
                break
            }
        },
        mtdresultadofaturamento() {   
                        
            this.displayperiodo = `${this.pdtini} até ${this.pdtfim}`;

            let neycards = this.droppedCards;

            neycards.forEach(card => {
                card.key = this.mtdGerarStringAleatoria();
                if (card.props) {
                    card.props.pdtini     = this.pdtini;
                    card.props.pdtfim     = this.pdtfim;
                    card.props.lstfiliais = this.lstfiliais;
                }
            });

            this.droppedCards = null;
            this.droppedCards = JSON.parse(JSON.stringify(neycards));

            this.saveView();                
        },
        toggleSidebar() {
            this.isSidebarCollapsed = !this.isSidebarCollapsed;
        },
        handleDragStart(card) {
            if (this.isCardDropped(card.id)) {
                this.draggedCard = null;
                return;
            }
            this.draggedCard = card;
        },
        mtdcliqueduplo(card){
            console.log("card:",card)
            this.handleDragStart(card);

            setTimeout(() => {
                this.handleDrop();
            }, 200);
        },
        handleDrop() {
            if (this.draggedCard && !this.isCardDropped(this.draggedCard.id)) {

                this.draggedCard.key = this.mtdGerarStringAleatoria(); 

                this.draggedCard.props = {
                    utodasfiliais: 0,
                    idfilialmeta : 0,
                    pdtini       : this.pdtini,
                    pdtfim       : this.pdtfim,
                    lstfiliais   : this.lstfiliais,
                    qtdnotaspendentes: 0,
                }
                this.droppedCards.push({ ...this.draggedCard });
                this.saveView();
            }
            this.draggedCard = null;
        },
        isCardDropped(cardId) {
            return this.droppedCards.some((c) => c.id === cardId);
        },
        removeCard(cardId) {
            this.droppedCards = this.droppedCards.filter((c) => c.id !== cardId);
            this.saveView();
        },
        saveView() {
            let vself = this;
            //salva as informações do dash no tbusuarios com o formato json
            let parametros      = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           valor  : 'salvadashboard'},
                {parametro: 'idusuario',    valor  : vself.$store.state.usuario.id},
                {parametro: 'dashboard',    valor  : JSON.stringify(this.droppedCards)},
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
            retorno.then(function (response) {
                
            }).catch(function (response) {
                
            });
        },
    },
    watch: {
    
    },
    computed: {
        usuariologado(){
            return this.$store.state.usuario;
        },
       
    }
};
</script>

<style scoped>
.container-fluid {
    height: 100vh;
}

.sidebar {
    width: 300px;
    transition: width 0.3s ease;
    overflow-y: auto;
}

.sidebar.collapsed {
    width: 60px;
    padding: 0.5rem;
}

.dropzone {
    min-height: 100%;
    border: 2px dashed #ccc;
}
.icone-gira-cima {
    position: relative;
    top: -2px;
    left: -1px;
    font-size: 12px;
    margin-left: 2px;
    margin-top: 7px;
    transition: transform 0.3s ease-in-out;
    transform: rotate(0deg);
}
.icone-gira-baixo {
    position: relative;
    top: -2px;
    left: -1px;    
    font-size: 12px;
    margin-left: 2px;
    margin-top: 7px;
    transition: transform 0.3s ease-in-out;
    transform: rotate(-180deg);
}  

/*.card-drograble {
    min-height: 300px;
   
    max-height: 400px;
   
    height: 100%;
    display: flex;
    flex-direction: column;
}/*

.card-drograble .card-body {
    flex: 1;
   
    overflow: auto;
}

/* Ajuste para os cards específicos */
.card-dash {
    padding: 0.5rem 1rem;
    /* Reduz o padding do cabeçalho */
}

.drag-handle {
    user-select: none;
    /* Evita seleção de texto ao arrastar */
}

.chart-container {
    position: relative;
    height: calc(100% - 40px);
    /* Ajuste conforme o cabeçalho */
    min-height: 200px;
}
.dropzone{
    border: 2px #ccc!important;
    padding-top: 0px !important;
}
.btn-widget-dash{
    color: #666;
    text-decoration: none!important;
} 

.listacards::-webkit-scrollbar:horizontal {
    height: 8px;
    -webkit-border-radius: 8px;
    border-radius: 8px;
}
.listacards::-webkit-scrollbar-thumb:horizontal {
    -webkit-border-radius: 8px;
    border-radius: 8px;
    background: #53687757;
}
.listacards::-webkit-scrollbar-track:horizontal {
    background-color: transparent;
}
</style>
